import React from 'react';
import PropTypes from 'prop-types';
import { compose, withProps } from 'recompose';

import { Image } from 'components/core/Image/index';
import { Button } from 'components/core/Button/index';
import { H3, H4 } from 'components/core/Typography';
import { Group } from 'components/core/Page';
import { SearchBox } from 'components/search/SearchBox/index';
import { buildSearchLink } from 'lib/search';
import withSearchHandler from 'decorators/withSearchHandler';

import selfStorageImage from 'assets/images/icons/self-storage.svg';
import truckStorageImage from 'assets/images/icons/truck-storage.svg';

import './truckSearchBlock.scss';

export const enhance = compose(
	withProps({
		searchType: 'trucks'
	}),
	withSearchHandler
);

export function TruckSearchBlock({
	handleSearch,
	withSearch,
	headerText,
	subHeaderText,
	buttonText,
	location,
	searchType
}) {
	return (
		<div className="section-container truck-search-block">
			<div className="icon-header">
				<Image src={selfStorageImage} className="item" width={25} height={21} />
				<div className="item plus">+</div>
				<Image src={truckStorageImage} className="item" width={56} height={46} />
			</div>
			<H3 size="huge">
				{headerText}
			</H3>
			{!!subHeaderText &&
				<Group>
					<H4
						size="large"
						weight="medium"
					>
						{subHeaderText}
					</H4>
				</Group>
			}
			{!!buttonText && !!location &&
				<Button
					href={buildSearchLink({
						searchType,
						location: `${location.city}, ${location.state}`
					})}
					rel="nofollow"
					dark
				>
					{buttonText}
				</Button>
			}
			{withSearch &&
				<SearchBox
					handleSearch={handleSearch}
					darkButton
					id="truck-search-input"
				/>
			}
		</div>
	);
}

TruckSearchBlock.propTypes = {
	handleSearch: PropTypes.func,
	withSearch: PropTypes.bool,
	headerText: PropTypes.string.isRequired,
	subHeaderText: PropTypes.string,
	buttonText: PropTypes.string,
	searchType: PropTypes.string,
	location: PropTypes.shape({
		city: PropTypes.string.isRequired,
		state: PropTypes.string.isRequired
	})
};

export default enhance(TruckSearchBlock);
